import React from "react";

const TopBanner = ({ titleText }) => {
  return (
    <div>
      <div className="bg-banner-background h-24 lg:h-20 bg-no-repeat bg-cover w-full mb-4">
        <div className="w-full h-full bg-primeColor bg-opacity-80 flex justify-center items-center">
          <h1 className="font-titleFont text-white text-4xl text-center font-semibold">
            {titleText}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
